<template>
  <div class="w-50 setting-usertypes">

    <div class="table-responsive">
      <table class="table">
        <colgroup>
          <col width="50">
          <col width="50">
          <col>
          <col width="100">
          <col width="100">
        </colgroup>
        <tbody>
          <tr v-for="(userType, index) in userTypes" :key="index">
            <td>{{ index + 1 }}.</td>
            <td class="text-center">
              <span :class="['badge w-100', 'badge-' + (userType.color_class ? userType.color_class : 'secondary')]">&nbsp;</span>
            </td>
            <td>
              <strong>{{ userType.title }}</strong>
            </td>
            <td align="right">
              <a href="javascript:;" class="icon-pencil" v-tooltip="'Edit User Type'" @click="editUserType( index )"></a>
            </td>
            <td align="left">
              <a href="javascript:;" class="icon-trash" v-tooltip="'Delete User Type'" v-if="userType.deletable" @click="confDelete( index )"></a>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5">
              <button type="button" class="btn btn-outline-black" @click="showModalAdd = true">
                + Add New</button>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <modal-add-user-type v-model="showModalAdd"
      @usertype-added="onUserTypeAdded"></modal-add-user-type>
    <modal-edit-user-type v-model="showModalEdit"
      :usertype="activeItem" @usertype-saved="onUserTypeSaved"></modal-edit-user-type>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ServiceUserType from '@/services/usertype'
import ModalAddUserType from './ModalAddUserType'
import ModalEditUserType from './ModalEditUserType'

export default {
  components: {
    ModalAddUserType,
    ModalEditUserType,
  },
  data () {
    return {
      showModalAdd: false,
      showModalEdit: false,
      activeIndex: -1,
    }
  },
  computed: {
    ...mapGetters(['OPTIONS']),
    userTypes () {
      let self = this;
      return self.OPTIONS.user_types;
    },
    activeItem () {
      let self = this;
      return self.userTypes[self.activeIndex] ? self.userTypes[self.activeIndex] : null;
    },
  },
  // computed: mapState({
  //   userTypes: state => state.setting.userTypes,
  //   activeItem () {
  //     let self = this;
  //     return self.userTypes[self.activeIndex] ? self.userTypes[self.activeIndex] : null;
  //   },
  // }),
  mounted () {
  },
  methods: {
    editUserType ( index ) {
      let self = this;
      self.activeIndex = index;

      self.showModalEdit = true;
    },
    onUserTypeSaved ( userType ) {
      let self = this, userTypes = self.userTypes;

      userTypes.splice( self.activeIndex, 1, userType );
      self.$store.dispatch( 'SET_USER_TYPES', userTypes );
    },
    onUserTypeAdded ( userType ) {
      let self = this, userTypes = self.userTypes;
      userTypes.push( userType );
      self.$store.dispatch( 'SET_USER_TYPES', userTypes );
    },
    confDelete ( index ) {
      let self = this, item = self.userTypes[index];

      self.$dialog
        .confirm('Are you sure you want to delete user type "<strong>' + item.title + '</strong>"?', {
          html: true,
          loader: true,
          okText: "Yes, I'm sure",
          cancelText: "Cancel",
        })
        .then(dialog => {
          ServiceUserType.delete(item.id, resp => {
            dialog.close();

            if ( resp.status == 'SUCCESS' ) {
              self.$notify({
                type: 'success',
                text: 'User type <strong>' + item.title + '</strong> has been deleted'
              });

              let userTypes = self.userTypes;
              userTypes.splice( index, 1 );
              self.$store.dispatch( 'SET_USER_TYPES', userTypes );
            }
            else {
              self.$notify({
                type: 'error',
                text: resp.error
              });
            }
          });
        })
        .catch(() => {})
      ;
    },
  }
}
</script>
